import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import Avatar from '../Avatar';
import HelpIcon from '../HelpIcon';

const AccessModalListItem = ({
  item,
  saving,
  handleRemoveItem,
}) => {
  const intl = useIntl();

  const removeItem = (e) => {
    e.preventDefault();
    handleRemoveItem(item.uuid, item.type);
  };

  return (
    <div className="user-item">
      <Avatar
        user={item}
        icon={item.type === 'group' ? 'users-class' : 'user'}
      />
      <div className="user-item-body">
        <h6 className={`user-item-title${item.hasAccessToCollectionGroup ? '' : ' user-item-title-not-allowed'}`}>
          {item.name}
          {!item.hasAccessToCollectionGroup && (
            <HelpIcon id={`access-${item.uuid}`}>
              {intl.formatMessage({
                defaultMessage: `This {item} does not have access to the Collection group that this 
                  Collection belongs to. They will not be given access to this Collection or its files.`,
              }, { item: item.type })}
            </HelpIcon>
          )}
        </h6>
        {item.email && (
          <span className="user-item-details">
            {item.email}
          </span>
        )}
      </div>
      <div className="user-item-actions">
        <Button color="link" disabled={saving} onClick={removeItem}>
          <i className="far fa-times" />
        </Button>
      </div>
    </div>
  );
};

AccessModalListItem.propTypes = {
  item: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired,
  handleRemoveItem: PropTypes.func.isRequired,
};

export default AccessModalListItem;
